/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_StartInputs */

const vi_import_start = /** @type {(inputs: Import_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu import`)
};

/**

* @param {Import_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_start = /** @type {((inputs?: Import_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_start(inputs)
});